import { useState, useEffect } from "react";
import styles from "./shared.module.css"

import { useSelector } from "react-redux";

const AccessController = ({ roles, modules, children }) => {
  const { loading, user } = useSelector((state) => state.user);

  if (!user?.module || !user?.role)
    return (
      <div className="">
        You do not have sufficient permissions to view this page.
      </div>
    );

  if (!modules.includes(user.module) || !roles.includes(user.role)) {
    return (
      <div className="">
        You do not have sufficient permissions to view this page.
      </div>
    );
  }

  return <> {children} </>;
};

const AccessController2 = ({ roles, children }) => {
  const { loading, user } = useSelector((state) => state.user);

  if (!user?.role)
    return (
      <div className={styles.container}>
        <p>You do not have sufficient permissions to view this page.</p>
        <button className={styles.button}
          onClick={() => {
            window.location.href = "/";
          }}
        >Return to Home Page</button>
      </div>
    );

  if (!roles.includes(user.role)) {
    return (
      <div className={styles.container}>
        <p>You do not have sufficient permissions to view this page.</p>
        <button className={styles.button}
          onClick={() => {
            window.location.href = "/";
          }}
        >Return to Home Page</button>
      </div>
    );
  }

  return <> {children} </>;
};

export default AccessController2;
